import type { DashboardDefinition } from 'common/types/dashboard/dashboardDefinition';
import type { SummaryViewKind } from '../index';

// Mirrors DEFAULT_GRID_COLUMNS in backend/apps/summary_definitions/dashboard_schema.py.
const DEFAULT_DASHBOARD_GRID_COLUMNS = 3;

// Dashboard-kind definitions carry no meaningful spreadsheet payload, so callers must branch on
// this before feeding a definition into any spreadsheet path (row queries, the column editor).
export const isDashboardDefinition = (
  definition?: { view_kind?: SummaryViewKind } | null
): boolean => definition?.view_kind === 'dashboard';

// Mirrors default_dashboard_definition() in dashboard_schema.py. The backend rejects
// view_kind='dashboard' with an empty dashboard_definition, so this is the minimum valid payload
// for a new dashboard. Returns a fresh object per call so callers can never share or mutate one.
export const createEmptyDashboardDefinition = (): DashboardDefinition => ({
  version: 1,
  layout: { columns: DEFAULT_DASHBOARD_GRID_COLUMNS },
  components: [],
});
